











































































import Vue from "vue";
import GROUP_QUERY from "@/graphql/GroupQuery.gql";
import { GroupQuery_group, GroupQuery_group_sessions } from "@/graphql/generatedTypes/GroupQuery";
import formatUtils from "@/components/FormatUtil";
import BiggerPicture from "@/components/home/BiggerPicture.vue";
import ContactUsForm from "@/components/ContactUsForm.vue";
import GroupSessionTime from "@/components/GroupSessionTime.vue";

export default Vue.extend({
  name: "GroupCourse",
  components: { BiggerPicture, ContactUsForm, GroupSessionTime },
  apollo: {
    group: {
      query: GROUP_QUERY,
      variables(): { id: string } {
        return {
          id: this.groupId
        };
      }
    }
  },
  data() {
    return {
      groupId: this.$route.params.id,
      group: {} as GroupQuery_group,
      sessionConfig: [
        {
          subtitle: "Welcome to The Inner Matrix. Prepare for what's ahead and meet your intro."
        },
        {
          path: "session_details_1_path",
          subtitle: "Step into your mindfulness practice."
        },
        {
          path: "session_details_2_path",
          subtitle: "Step further into your mindfulness practice."
        },
        {
          path: "session_details_3_path",
          subtitle: "Create a vision for optimal health."
        },
        {
          path: "session_details_4_path",
          subtitle: "Practice transcending the thoughts, emotions and physical body to create a vision."
        },
        {
          path: "session_details_5_path",
          subtitle: "Congratulations on completing your Inner Matrix Intros!"
        }
      ]
    };
  },
  methods: {
    ...formatUtils,
    sessionPath(session: GroupQuery_group_sessions) {
      return this.sessionConfig[session.order].path;
    },
    sessionSubtitle(session: GroupQuery_group_sessions) {
      return this.sessionConfig[session.order].subtitle;
    }
  }
});
